<template>
    <div class="card col-lg-6 col-xs-12 p-0">
        <div class="card-body">
            <h3 class="font-600 mb-2">Change Password</h3>
            <div class="row">
                <div class="col-lg-2 col-xs-12 text-center mb-1">
                    <button class="btn btn-rounded btn-primary p-1">
                        <span class="material-icons" style="font-size: 35px;">lock</span>
                    </button>
                </div>
                <div class="col align-self-center">
                    <p class="f-14">To protect the security of your account, enter your current password. New password will be used to login, please enter at least 8 characters</p>
                </div>
            </div>
            <div class="row mt-1">
                <div class="col">
                    <ValidationObserver ref="observer2">
                        <form @submit.prevent="isChange()">
                            <ValidationProvider name="current password" rules="required|min:8" v-slot="{ errors }">
                                <div class="form-group input-group mb-0" :class="{ 'validation-warning': errors[0] }">                            
                                    <input :type="show_oldPassword ? 'text' : 'password'" v-model="model.oldPassword" class="form-control border-right-0" placeholder="Enter current password">
                                    <label class="form-control-placeholder" for="password">CURRENT PASSWORD</label>
                                    <span class="input-group-append">
                                        <div class="input-group-text">
                                            <a href="javascript:;" @click="show_oldPassword = !show_oldPassword" class="text-blue">
                                                <i :class="show_oldPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                            </a>
                                        </div>
                                    </span> 
                                </div>
                                <small class="val-error" v-if="errors[0]">{{ errors[0] }}</small>
                            </ValidationProvider>
                            <hr>
                            <ValidationProvider name="new password" rules="required|min:8" v-slot="{ errors }">
                                <div class="form-group input-group mb-0" :class="{ 'validation-warning': errors[0] }">                            
                                    <input :type="show_newPassword ? 'text' : 'password'" v-model="model.newPassword" class="form-control border-right-0" placeholder="Enter new password" ref="New password">
                                    <label class="form-control-placeholder" for="password">NEW PASSWORD</label>
                                    <span class="input-group-append">
                                        <div class="input-group-text">
                                            <a href="javascript:;" @click="show_newPassword = !show_newPassword" class="text-blue">
                                                <i :class="show_newPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                            </a>
                                        </div>
                                    </span> 
                                </div>
                                <small class="val-error" v-if="errors[0]">{{ errors[0] }}</small>
                            </ValidationProvider>
                            <ValidationProvider name="confirm new password" rules="required|confirmed:new password|min:8" v-slot="{ errors }">
                                <div class="form-group input-group mb-0 mt-2" :class="{ 'validation-warning': errors[0] }">                            
                                    <input :type="show_conf_newPassword ? 'text' : 'password'" v-model="model.conf_newPassword" class="form-control border-right-0" placeholder="Enter new password confirmation" data-vv-as="New password">
                                    <label class="form-control-placeholder" for="password">NEW PASSWORD CONFIRMATION</label>
                                    <span class="input-group-append">
                                        <div class="input-group-text">
                                            <a href="javascript:;" @click="show_conf_newPassword = !show_conf_newPassword" class="text-blue">
                                                <i :class="show_conf_newPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                            </a>
                                        </div>
                                    </span> 
                                </div>
                                <small class="val-error" v-if="errors[0]">{{ errors[0] }}</small>
                            </ValidationProvider>
                            <p class="mt-1"><small><b>Hint</b>: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbol like ! " ? $ % ^ )</small></p>
                            <hr>
                            <div class="mt-1">
                                <router-link to="/" class="btn text-danger">Cancel</router-link>
                                <button type="submit" class="btn btn-primary" :disabled="isLoading">
                                    <div v-if="isLoading">Saving <i class="fa fa-spinner fa-spin"></i></div>
                                    <div v-else>Save</div>
                                </button>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: {
                oldPassword: null,
                newPassword: null,
                conf_newPassword: null
            },
            show_oldPassword: false,
            show_newPassword: false,
            show_conf_newPassword: false,
            isLoading: false,
            state: 2
        }
    },
    methods: {
        save() {
            let _ = this
            _.isLoading = true
            _.axios.put('accounts/password', _.model)
                .then(resp => {
                    _.$swal.fire({
                        title: resp.data.message,
                        text: 'Silahkan Login Kembali',
                        icon: 'success',
                        confirmButtonColor: '#0036A0',
                        confirmButtonText: 'OK'
                    })
                    
                    _.$store.dispatch('logout')
                    window.location = '/login'
                })
                .catch(err => {
                    _.$notify({
                        type: 'error',
                        title: 'Error!',
                        text: err.response.data.message,
                    })
                    _.isLoading = false
                })
        },
        async isChange(){
            let _ = this
            const isValid = await _.$refs.observer2.validate()
            if (isValid){
                _.$swal.fire({
                    title: 'Are you sure you want to change your password?',
                    html: '<p class="popup-text-normal">You will be logged out automatically when you change your password.</p>',
                    icon: 'question',
                    showCancelButton: true,
                    cancelButtonText: 'Cancel',
                    confirmButtonColor: '#0036A0',
                    confirmButtonText: 'Continue',
                    }).then((result) => {
                        if (result.value) {
                            _.save()
                        }
                    })
            }
        }
    }
}
</script>